import isObject from 'lodash-es/isObject';

type ErrorWithDetail = {
  detail: string;
};

function isErrorWithDetail(error: unknown): error is ErrorWithDetail {
  return isObject(error) && 'detail' in error && typeof (error as Record<string, unknown>).detail === 'string';
}

export function getErrorDetail(error: unknown): string {
  return isErrorWithDetail(error) ? error.detail : '';
}
